<template>
  <div class="onlineExhibition">
    <div class="statusBar"></div>

    <div class="swiper">
      <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
      <van-swipe @change="onChange">
        <van-swipe-item v-for="item in detailInfo.imgeUrlList"> <img :src="item" alt="" class="swiper_img" /> </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator" v-if="detailInfo.imgeUrlList && detailInfo.imgeUrlList.length > 0">{{ current + 1 }}/{{ detailInfo.imgeUrlList.length }}</div>
        </template>
      </van-swipe>
    </div>
    <div v-if="type == 0 && detailInfo.notice">
      <van-notice-bar left-icon="volume" scrollable>
        <span v-html="detailInfo.notice"></span>
      </van-notice-bar>
    </div>
    <div class="introduction" v-if="type == 0">
      <div class="d-f jc-sb ai-c">
        <span class="title">{{ detailInfo.venueName }}</span>
      </div>
      <div class="common_msg date d-f ai-c">
        <img src="@/assets/images/detail/address.png" alt="" class="icon" />
        <span class="detail">地址：{{ detailInfo.address }}</span>
        <span class="shuline">|</span>
        <span>{{ detailInfo.distance | setMorKm }}km</span>
        <img src="@/assets/images/detail/performance/navigation.png" @click="UNInavigation" alt="" class="address1" />
      </div>
      <div class="common_msg d-f ai-c">
        <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
        <span>电话：{{ detailInfo.venuePhone }}</span>
        <img src="@/assets/images/detail/performance/phone.png" alt="" class="address1" />
      </div>
      <div class="common_text d-f ai-c">{{ detailInfo.openHour }}</div>
      <div class="d-f jc-sb ai-c m-t">
        <span class="title">场馆简介</span>
      </div>
      <div class="common_details" v-html="detailInfo.introduce" />
      <!-- <span class="more">展开<img src="@/assets/images/detail/more.png" alt="" class="more-img" /></span> -->
      <!-- </div> -->
      <div class="d-f jc-sb ai-c m-t" v-if="detailInfo.siteList && detailInfo.siteList.length > 0">
        <span class="title">场地</span>
      </div>

      <div class="van-swipe2">
        <van-swipe :width="160" :loop="false" indicator-color="white" class="back-swipe">
          <van-swipe-item v-for="item in detailInfo.siteList">
            <div class="livePlayback-item">
              <img :src="item.imgUrl" alt="" class="livePlayback-img" />
              <div class="text">{{ item.siteName }}</div>
              <div class="status" v-if="item.status == 1">可预约</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="introduction_site" v-if="type == 1">
      <div class="d-f jc-sb ai-c">
        <span class="title">{{ detailInfo.siteName }}</span>
      </div>
      <div class="venue d-f jc-sb ai-c">
        <span class="title">所属场馆：{{ detailInfo.venueName }}</span>
      </div>
      <div class="common_msg date d-f ai-c">
        <img src="@/assets/images/detail/address.png" alt="" class="icon" />
        <span class="detail">地址：{{ detailInfo.address }}</span>
        <span class="shuline">|</span>
        <span>{{ detailInfo.distance | setMorKm }}km</span>
        <img src="@/assets/images/detail/performance/navigation.png" @click="UNInavigation" alt="" class="address1" />
      </div>
      <div class="link"></div>
      <div class="opening-hours">开放时间：{{ detailInfo.openHour }}</div>
      <div class="link"></div>
      <div class="contacts">联系人：{{ detailInfo.applicantName }}</div>
      <div style="display: flex">
        <div class="contact-information">联系方式：{{ handleDecryptPhone(detailInfo.applicantPhone) }}</div>
        <div class="contact-information" style="display: flex; align-items: center">
          <img src="@/assets/images/detail/performance/phone.png" alt="" class="icon_phone" @click="callphone(detailInfo.applicantPhone)" />
        </div>
      </div>
      <div class="link"></div>

      <div class="area">
        <span>场地面积：</span><span class="bold">{{ detailInfo.square }}m²</span>
      </div>
      <div class="area">
        <span>最多容纳：</span><span class="bold">{{ detailInfo.capacity }}人</span>
      </div>
      <div class="facilities d-f ai-c" v-show="detailInfo.facility">
        <span>场地设施：</span>
        <div class="bold" v-html="detailInfo.facility" />
      </div>
      <div class="link"></div>
      <div class="d-f jc-sb ai-c m-t">
        <span class="title">场地简介</span>
      </div>
      <div class="common_details" v-html="detailInfo.introduce" />
      <!-- <span class="more">展开<img src="@/assets/images/detail/more.png" alt="" class="more-img" /></span> -->
      <!-- </div> -->
    </div>

    <div class="handle_button d-f jc-sb ai-c">
      <div class="d-f ai-c" @click="share">
        <div class="handle_item d-f ai-c border_right">
          <img src="@/assets/images/detail/performance/circle_share.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
      </div>
      <!-- 场馆预约状态(1-可进行预约，2-暂不开放预约，3-暂未设置可预约时段) -->
      <div class="btn" :class="detailInfo.appointStatus == 1 ? '' : 'disabled'" @click="order">
        {{ detailInfo.appointStatus == 1 ? '场地预定' : detailInfo.appointStatus == 2 ? '暂未设置开放时段' : '暂未设置可预约时段' }}
      </div>
    </div>
    <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getVenueData, getSiteData } from '@/api/venue'
import { getToken, getVenueToken } from '@/utils/auth'
import config from '@/utils/config.js'
import { encrypt, decrypt } from '@/utils/sm4'

export default {
  name: 'venueSite',
  data() {
    return {
      current: 0,
      tabs: ['详情介绍', '展览展示'],
      tabIndex: 0,
      showShare: false,
      queryData: {},
      detailInfo: {},
      type: 0,
      id: '',
      shareUrl: config.shareUrl,
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    handleDecryptPhone(value) {
      return decrypt(value)
    },
    UNInavigation() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNInavigation',
          data: {
            name: this.detailInfo.address,
            latitude: this.detailInfo.latitude,
            longitude: this.detailInfo.longitude,
          },
        },
      })
    },
    share() {
      if (getToken()) {
        // this.showShare = true
        this.handleShare()
      } else {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',
            data: {
              id: this.id,
              url: '/detail/venueSite',
              needLocation: true,
            },
          },
        })
        // this.$myUni.navigateTo({
        //   url: '/pages/login/index',
        // })
      }
    },
    handleShare() {
      const url = `${this.shareUrl}/share/venueSite?id=${this.id}`
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIShare',
          UNISharedata: {
            // 微信好友 朋友圈 QQ好友 复制链接
            // shareType: option.name,
            shareUrl: url,
            // id: this.queryData.id,
            title: this.detailInfo.name,
            // subTitle: '',
            picUrl: this.detailInfo.picUrl,
          },
        },
      })
    },
    back() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIBack',
        },
      })
    },
    onChange(index) {
      this.current = index
    },
    changeTab(index) {
      if (index !== this.tabIndex) {
        this.tabIndex = index
      }
    },
    // goSite(id) {
    //   this.$router.push({
    //     path: '/detail/venueVenue',
    //     query: {
    //       id,
    //       latitude: this.queryData.latitude,
    //       longitude: this.queryData.longitude,
    //     },
    //   })
    // },
    getDetail() {
      if (this.type == 0) {
        getVenueData(this.queryData).then((res) => {
          this.detailInfo = res.result
        })
      } else {
        getSiteData(this.queryData).then((res) => {
          this.detailInfo = res.result
        })
      }
    },
    order() {
      console.log(111, 111)
      if (!getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',
            data: {
              id: this.id,
              url: '/detail/venueSite',
              needLocation: true,
            },
          },
        })
        // this.$myUni.navigateTo({
        //   url: '/pages/login/index',
        // })
        return
      }
      if (this.detailInfo.appointStatus == 1 && this.type == 0) {
        this.$router.push({
          path: '/reservation/reservation',
          query: {
            id: this.id,
            type: this.type,
            venueName: this.detailInfo.venueName,
            siteName: this.detailInfo.venueName || '',
            address: this.detailInfo.address,
            distance: this.detailInfo.distance,
            latitude: this.detailInfo.latitude,
            longitude: this.detailInfo.longitude,
          },
        })
      } else if (this.detailInfo.appointStatus == 1 && this.type == 1) {
        this.$router.push({
          path: '/reservation/reservationSite',
          query: {
            id: this.id,
            type: this.type,
            venueName: this.detailInfo.venueName,
            siteName: this.detailInfo.siteName || '',
            address: this.detailInfo.address,
            distance: this.detailInfo.distance,
            latitude: this.detailInfo.latitude,
            longitude: this.detailInfo.longitude,
          },
        })
      }
    },
    callphone(phonenumber) {
      let phone = this.handleDecryptPhone(phonenumber)
      console.log(phone)
      window.location.href = 'tel://' + phone
    },
  },
  mounted() {
    let data = {}
    if (this.$route.query.params) {
      data = JSON.parse(this.$route.query.params)
    } else {
      data = this.$route.query
    }
    const { id, latitude, longitude, type } = data
    // type 0 场馆 1 场地
    this.type = 1
    this.id = id
    if (this.type == 0) {
      this.queryData = { ...this.queryData, venueId: id, latitude, longitude }
    } else {
      this.queryData = { ...this.queryData, siteId: id, latitude, longitude }
    }
    this.getDetail()
  },
}
</script>
<style lang="scss">
.shuline {
  padding: 0 0.2rem;
}
.onlineExhibition {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #fff;
  }

  .collect_button {
    padding-top: 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2.4rem;
    .collect {
      font-size: 0.7rem;
      font-weight: 400;
      color: #212121;
      img {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 8px;
      }
    }
  }
  .swiper {
    width: 100%;
    // height: 10.55rem;
    height: 18.75rem;
    // .van-swipe {
    //   height: 18.75rem;
    // }
    .back {
      z-index: 10;
      // position: absolute;
      position: fixed;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 48px;

      // top: calc(0.5rem + env(safe-area-inset-top));
    }

    .swiper_img {
      width: 100%;
      height: 18.75rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 8px;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .van-notice-bar {
    height: 1.4rem !important;
    color: #ff9639 !important;
    background: #fff5e7 !important;
  }
  .introduction {
    padding: 0.8rem 0;
    padding-bottom: calc(4rem + env(safe-area-inset-bottom));
    margin: 0 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
      .address1 {
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.8rem;
      }
    }
    .van-swipe2 {
      margin-top: 0.6rem;
      .livePlayback-item {
        position: relative;
        display: flex;
        flex-direction: column;
        .status {
          position: absolute;
          top: 0;
          left: 0;
          width: 2.4rem;
          height: 0.9rem;
          background: #d99a6e;
          border-radius: 0.5rem 0px 0.5rem 0px;
          font-size: 0.6rem;
          color: #ffffff;
          line-height: 0.9rem;
          text-align: center;
        }
        .livePlayback-img {
          width: 7.2rem;
          height: 7.2rem;
          border-radius: 0.5rem;
        }
        .text {
          width: 7.2rem;
          height: 1rem;
          font-size: 0.7rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #212121;
          line-height: 1rem;
          margin-top: 0.4rem;
        }
      }
    }
    .common_details {
      margin-top: 0.6rem;
      // height: 4rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;

      .more {
        // color: #47988a;
        color: #a97048;
        // display: flex;
        // align-items: center;
        line-height: 1rem;
        .more-img {
          padding-top: 0.2rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .common_text {
      margin-top: 0.4rem;
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
    .m-t {
      margin-top: 1.2rem;
    }
  }

  .introduction_site {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    padding-bottom: calc(4rem + env(safe-area-inset-bottom));

    // border-bottom: 1px solid #f4f4f4;
    .venue {
      .title {
        height: 1.1rem;
        font-size: 0.7rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 1.1rem;
      }

      margin-top: 0.6rem;
    }
    .link {
      //   height: 1px;
      border: 1px dotted #eeeeee;
    }

    .area {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.45rem;
      margin-top: 0.55rem;
      .bold {
        font-weight: 600;
        color: #333333;
      }
    }
    .accommodate {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.45rem;
      .bold {
        font-weight: 600;
        color: #333333;
      }
    }
    .m-t {
      margin-top: 1.2rem;
    }
    .common_details {
      margin-top: 0.6rem;
      // height: 4rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;
      .more {
        color: #47988a;
        // display: flex;
        // align-items: center;
        line-height: 1rem;
        .more-img {
          padding-top: 0.2rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .facilities {
      // height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.55rem;
      .bold {
        font-weight: 600;
        color: #333333;
        width: 13rem;
      }
    }

    .contact-information {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.55rem;
    }
    .contacts {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-top: 0.55rem;
      margin-bottom: 0.4rem;
    }
    .opening-hours {
      // height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-top: 0.55rem;
      margin-bottom: 0.55rem;
    }
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
      .address1 {
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.8rem;
      }
    }
    .van-swipe2 {
      margin-top: 0.6rem;
      .livePlayback-item {
        display: flex;
        flex-direction: column;
        .livePlayback-img {
          width: 7.2rem;
          height: 4.8rem;
        }
        .text {
          width: 7.2rem;
          height: 1rem;
          font-size: 0.7rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #212121;
          line-height: 1rem;
          margin-top: 0.4rem;
        }
      }
    }
    .common_details {
      margin-top: 0.6rem;
      // height: 4rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;
      .more {
        color: #47988a;
        // display: flex;
        // align-items: center;
        line-height: 1rem;
        .more-img {
          padding-top: 0.2rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .common_text {
      margin-top: 0.4rem;
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
    .m-t {
      margin-top: 1.2rem;
    }
  }

  .detail_tabs {
    padding: 0.75rem 0.6rem 0 0.6rem;
    padding-bottom: calc(2.5rem + env(safe-area-inset-bottom));

    .tab_item {
      position: relative;
      font-size: 0.8rem;
      color: #999999;
      line-height: 1.2rem;
      margin-right: 0.8rem;
      &.active {
        font-weight: 600;
        color: #212121;
        &::before {
          content: '';
          display: inline-block;
          width: 1.6rem;
          height: 2px;
          background: #47988a;
          border-radius: 2px;
          position: absolute;
          left: calc(50% - 0.8rem);
          bottom: -4px;
        }
      }
    }
    .content {
      margin-top: 0.9rem;
      .detail_msg {
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
      }
      .exhibition {
        .exhibition_item {
          img {
            width: 8.45rem;
            height: 8.45rem;
            border-radius: 0.5rem;
          }
          .title {
            font-size: 0.7rem;
            font-weight: 600;
            color: #212121;
            line-height: 1rem;
            margin: 0.4rem 0 0.6rem 0;
          }
        }
      }
    }
  }
  .handle_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    // color: #47988a;
    color: #a97048;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      // &.border_right {
      //   padding-right: 0.6rem;
      //   position: relative;
      //   ::after {
      //     position: absolute;
      //     content: '';
      //     display: inline-block;
      //     width: 1px;
      //     height: 0.7rem;
      //     top: 0.35rem;
      //     right: 0;
      //     background: #47988a;
      //   }
      // }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.2rem;
      }
    }
    .btn {
      width: 75%;
      // width: 13.75rem;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      // background: #47988a;
      background: #a97048;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
      &.disabled {
        background: #cccccc;
      }
    }
  }
  .icon_phone {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 1rem;
  }
}
</style>
